<div class="innerpage-fullwithbanner">
  <h2 class="bighead">Role & Permissions Management</h2>
  <ul class="bread-crumbs">
    <li><a (click)="Validation.redirect('/')">Home<span></span></a></li>
  </ul>
</div>
<div class="featuredproperties section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="row">
      <div class="col-lg-12 ">
        <div class="border-div table-fixed margin0">
          <div class="rightside clearfix">
            <label class="form-label">&nbsp;</label>
            <button type="button" class="right-btn btn-border margin-right-20 btn adduserbtn margin-bottom-15 pull-right" (click)="onDiscardChanges()" *ngIf="IsDiscardButtonVisible">Discard Changes</button>
            <button type="button" class="right-btn margin-right-20 btn adduserbtn margin-bottom-15 pull-right btn-success " style="background: #198fde !important;border-radius:35px;" (click)="SavePermissions()">Save Changes</button>
          </div>
          <div class="table-responsive permission-wrapper">
            <table class="table basictable permission-table">
              <thead>
                <tr>
                  <th>Modules / Actions</th>
                  <th *ngFor="let role of userRoles" style="text-align:center;">
                    {{ role.name }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <ng-container *ngFor="let module of modules">

                  <!-- MODULE HEADER -->
                  <tr class="module-row" (click)="toggleModule(module)">
                    <td [attr.colspan]="userRoles?.length + 1">
                      <span class="arrow">
                        <i class="fa fa-angle-right big-bold-icon" aria-hidden="true" *ngIf="!module.IsExpanded"></i>
                        <i class="fa fa-angle-down big-bold-icon" aria-hidden="true" *ngIf="module.IsExpanded"></i>
                      </span>
                      {{ module.ModuleName }}
                    </td>
                  </tr>

                  <!-- ACTION ROWS -->
                  <ng-container *ngIf="module.IsExpanded">
                    <tr *ngFor="let action of module.Actions" class="action-row scale-in-ver-top">
                      <td class="action-name" style="padding-left: 31px !important;">
                        {{ action.ActionName }}
                      </td>

                      <td *ngFor="let role of userRoles" class="role-cell ">
                        <label class="custom-checkbox withoutlabel">
                          <input type="checkbox"
                                 [ngModel]="getCurrentPermission(action, role)?.IsActive"
                                 (ngModelChange)="onPermissionToggle(action, role, $event)"
                                 [disabled]="getCurrentPermission(action, role)?.IsDenied"
                                 [ngModelOptions]="{ standalone: true }" />
                          <i></i>
                        </label>
                      </td>
                    </tr>
                  </ng-container>

                </ng-container>
              </tbody>


              <tfoot>
                <tr *ngIf="modules?.length == 0 ">
                  <td colspan="9" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
